/* Build a Bundle — selection state, progress, add-to-cart with _bundle properties. */
(function () {
  'use strict';

  function money(cents) {
    var fmt = window.tltMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  }

  function uuid() {
    return 'tlt-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  document.querySelectorAll('[data-bundle]').forEach(function (root) {
    var ready = root.dataset.bundleReady === 'true';
    var tiers = root.querySelectorAll('[data-bundle-tiers] input[type="radio"]');
    var products = root.querySelectorAll('[data-bundle-product]');
    var chipsWrap = root.querySelector('[data-bundle-chips]');
    var emptyMsg = root.querySelector('[data-bundle-empty]');
    var clearBtn = root.querySelector('[data-bundle-clear]');
    var progress = root.querySelector('[data-bundle-progress]');
    var progressInline = root.querySelector('[data-bundle-progress-inline]');
    var priceEl = root.querySelector('[data-bundle-price]');
    var savingsEl = root.querySelector('[data-bundle-savings]');
    var submit = root.querySelector('[data-bundle-submit]');
    var submitLabel = root.querySelector('[data-bundle-submit-label]');
    var noteWrap = root.querySelector('[data-bundle-note-wrap]');
    var noteInput = root.querySelector('[data-bundle-note]');
    var status = root.querySelector('[data-form-status]');

    /* selection: array of variant ids (duplicates allowed, COMMERCE.md §5) */
    var selection = [];
    var singleUnit = null; // cents, derived from first tile price text? use data below.

    function tierInput() {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].checked) return tiers[i];
      return tiers[0];
    }

    function tileFor(variantId) {
      return root.querySelector('[data-bundle-product][data-variant-id="' + variantId + '"]');
    }

    function counts() {
      var map = {};
      selection.forEach(function (id) { map[id] = (map[id] || 0) + 1; });
      return map;
    }

    function render() {
      var t = tierInput();
      var size = parseInt(t.value, 10);
      var price = parseInt(t.dataset.price, 10);
      var label = t.dataset.label;
      var n = selection.length;
      var remaining = size - n;
      var map = counts();

      /* tiles */
      products.forEach(function (tile) {
        var id = tile.dataset.variantId;
        var qty = map[id] || 0;
        tile.classList.toggle('is-selected', qty > 0);
        var qtyBadge = tile.querySelector('[data-bundle-qty]');
        var removeBtn = tile.querySelector('[data-bundle-remove]');
        if (qtyBadge) {
          qtyBadge.hidden = qty < 2;
          qtyBadge.textContent = '×' + qty;
        }
        if (removeBtn) removeBtn.hidden = qty === 0;
        var addBtn = tile.querySelector('[data-bundle-add]');
        if (addBtn) addBtn.disabled = remaining <= 0;
      });

      /* chips */
      if (chipsWrap) {
        chipsWrap.innerHTML = '';
        selection.forEach(function (id, idx) {
          var tile = tileFor(id);
          var title = tile ? tile.dataset.title : 'Little Thing';
          var li = document.createElement('li');
          li.className = 'bundle-chip';
          li.innerHTML = '<span>' + title + '</span>' +
            '<button type="button" class="bundle-chip__x" data-chip-index="' + idx + '" aria-label="Remove ' + title + ' from bundle">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button>';
          chipsWrap.appendChild(li);
        });
      }
      if (emptyMsg) emptyMsg.hidden = n > 0;
      if (clearBtn) clearBtn.hidden = n === 0;
      if (noteWrap) noteWrap.hidden = n === 0;

      /* progress + price */
      var progressText;
      if (remaining > 0) {
        progressText = n + ' of ' + size + ' selected · Choose ' + remaining + ' more';
      } else {
        progressText = 'Your bundle is ready';
      }
      if (progress) {
        progress.textContent = progressText;
        progress.classList.toggle('is-complete', remaining <= 0);
      }
      if (progressInline) progressInline.textContent = '(' + n + ' of ' + size + ')';
      if (priceEl) priceEl.textContent = money(price);
      if (savingsEl && singleUnit) {
        var value = singleUnit * size;
        savingsEl.textContent = 'Save ' + money(value - price);
      }

      /* CTA */
      if (submit) {
        submit.disabled = remaining > 0;
        if (submitLabel) {
          submitLabel.textContent = remaining > 0
            ? 'Choose ' + remaining + ' more'
            : 'Add ' + label + ' Bundle · ' + money(price);
        }
      }
    }

    /* derive single unit price from first tile's rendered price */
    (function () {
      var first = root.querySelector('.bundle-product__price');
      if (first) {
        var m = first.textContent.replace(/[^0-9.,]/g, '').replace(',', '.');
        var f = parseFloat(m);
        if (!isNaN(f)) singleUnit = Math.round(f * 100);
      }
    })();

    /* events */
    tiers.forEach(function (t) {
      t.addEventListener('change', function () {
        var size = parseInt(t.value, 10);
        if (selection.length > size) selection = selection.slice(0, size);
        render();
      });
    });

    root.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-bundle-add]');
      var removeBtn = e.target.closest('[data-bundle-remove]');
      var chipX = e.target.closest('[data-chip-index]');

      if (addBtn) {
        var tile = addBtn.closest('[data-bundle-product]');
        var size = parseInt(tierInput().value, 10);
        if (selection.length < size && tile.dataset.available === 'true') {
          selection.push(tile.dataset.variantId);
          render();
        }
        return;
      }
      if (removeBtn) {
        var rTile = removeBtn.closest('[data-bundle-product]');
        var idx = selection.lastIndexOf(rTile.dataset.variantId);
        if (idx > -1) { selection.splice(idx, 1); render(); }
        return;
      }
      if (chipX) {
        selection.splice(parseInt(chipX.dataset.chipIndex, 10), 1);
        render();
        return;
      }
      if (e.target.closest('[data-bundle-clear]')) {
        selection = [];
        render();
      }
    });

    /* tile tap adds too (bigger touch target on mobile) */
    products.forEach(function (tile) {
      tile.querySelector('.bundle-product__media').addEventListener('click', function (e) {
        if (e.target.closest('button')) return;
        if (tile.dataset.available !== 'true') return;
        var size = parseInt(tierInput().value, 10);
        if (selection.length < size) { selection.push(tile.dataset.variantId); render(); }
      });
    });

    if (submit) {
      submit.addEventListener('click', function () {
        if (!ready || selection.length === 0) return;
        var t = tierInput();
        var size = parseInt(t.value, 10);
        var parentVariant = parseInt(t.dataset.parentVariant, 10);

        /* Bundle integrity, enforced before anything reaches the cart.
           The parent SKU is priced for exactly `size` items, so adding it with
           any other count would charge the tier price for the wrong quantity.
           Fail closed: refuse to add rather than add something mispriced. */
        if (!parentVariant) {
          if (status) {
            status.textContent = 'Bundles are not available right now.';
            status.classList.add('field__error');
          }
          return;
        }
        if (selection.length !== size) {
          if (status) {
            status.textContent = 'Pick exactly ' + size + ' to build this bundle.';
            status.classList.add('field__error');
          }
          render();
          return;
        }

        var bundleId = uuid();
        var props = { _bundle_id: bundleId, _bundle_size: t.dataset.label };

        /* Structured picks, in the order the customer chose them, for cart
           display and fulfilment. Underscore-prefixed so Shopify's own
           checkout does not render eight raw rows; the theme renders them. */
        var titles = selection.map(function (id) {
          var tile = tileFor(id);
          return tile ? tile.dataset.title : 'Little Thing';
        });
        titles.forEach(function (title, i) {
          props['_selection_' + (i + 1)] = title;
        });
        /* Variant ids kept alongside the titles so fulfilment can resolve the
           exact SKUs even if a product is later renamed. */
        props._selection_ids = selection.join(',');

        /* One visible property, so the picks also appear at checkout and in the
           order confirmation email, where underscore properties are hidden. */
        props[window.tltBundleIncludesLabel || 'Includes'] = titles.join(', ');

        if (noteInput && noteInput.value.trim()) {
          props['Gift note'] = noteInput.value.trim();
        }

        var items = [{ id: parentVariant, quantity: 1, properties: props }];
        submit.classList.add('btn--loading');
        submit.disabled = true;
        window.tltCartAdd(items)
          .then(function () {
            selection = [];
            if (noteInput) noteInput.value = '';
            render();
            if (status) { status.textContent = ''; status.classList.remove('field__error'); }
          })
          .catch(function (err) {
            if (status) {
              status.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
              status.classList.add('field__error');
            }
          })
          .finally(function () {
            submit.classList.remove('btn--loading');
            render();
          });
      });
    }

    render();
  });
})();
